export default function Button({ children, disabled }) {
  return (
    <div className="primary-btn" disabled={disabled}>
      {children}
    </div>
  );
}
